import { render, staticRenderFns } from "./TButton.vue?vue&type=template&id=4451b484&"
import script from "./TButton.vue?vue&type=script&lang=ts&"
export * from "./TButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports